import { EditInlineDialogProps } from "../../../../types";
import DeleteLicense from "../../../shared/DeleteLicense";

const DeleteOfflineLicense = ({
    data,
    isOpen,
    close
}: EditInlineDialogProps) => {
    return <DeleteLicense data={data} isOpen={isOpen} close={close} />;
};

export default DeleteOfflineLicense;
